
import React from 'react';

export const GameControllerIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M22.04,11.23c-0.27-1.46-1.2-2.69-2.43-3.33c-0.89-0.47-1.92-0.7-2.98-0.7H7.37c-1.06,0-2.09,0.23-2.98,0.7 C3.16,8.54,2.23,9.77,1.96,11.23C1.75,12.35,1.8,13.5,2.1,14.58L3,17.62c0.23,0.87,1,1.52,1.9,1.52H6.9c0.41,0.61,0.91,1.14,1.5,1.58 c0.79,0.59,1.76,0.95,2.78,1.01h1.64c1.02-0.06,1.99-0.42,2.78-1.01c0.59-0.44,1.09-0.97,1.5-1.58h1.99 c0.9,0,1.67-0.65,1.9-1.52l0.9-3.04C22.2,13.5,22.25,12.35,22.04,11.23z M8.5,14H7v-3h1.5V14z M17,14h-1.5v-3H17V14z" />
  </svg>
);
